// date format used in WO details
export const format = 'DD/MM/YYYY HH:mm:ss';
export const calDateFormat = 'DD/MM/YYYY';
